var initializeTimelineBlock = function(block){

	jQuery('.slick', block).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: true,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: true
	});
	
	var year = jQuery('.slick-current .date .year', block).html();
	
	jQuery('.slick-dots .slick-active', block).append('<span class="year">' + year + '</span>');

	jQuery(".slick").on("afterChange", function(slick, currentSlide){
	
		year = jQuery('.slick-current .date .year', block).html();

		jQuery('.slick-dots .year').remove();
		jQuery('.slick-dots .slick-active', block).append('<span class="year">' + year + '</span>');
	
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-timeline').each(function(){
		initializeTimelineBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=timeline', initializeTimelineBlock);
